/** Человекочитаемые названия провайдеров OnlyFans API */
export const PROVIDER_LABELS = {
  onlyfansapi: 'OnlyFans API',
  onlymonster: 'OnlyMonster',
  fanltv_ofapi: 'FanLTV OFAPI Backup',
  fansly: 'Fansly',
  fanvue: 'Fanvue',
  telegram_account: 'Telegram',
  telegram_tribute: 'Telegram Tribute',
  telegram_bot_payments: 'Telegram Bot Payments',
  aigirlfactory: 'AIGirlFactory',
  instagram: 'Instagram',
}

export function getProviderLabel(provider) {
  return PROVIDER_LABELS[provider] ?? provider
}
